<template>
    <div class="min-w-max">
        <section class="flex justify-between bg-white rounded-lg border border-gray-200 px-5 text-gray-700 font-montserrat">
      <ul class="flex items-center">
        <li class="pr-6" v-if="hasPrev()">
          <a href="#" @click.prevent="changePage(prevPage)">
            <div class="flex items-center justify-center hover:bg-gray-200 rounded-md transform rotate-45 h-6 w-6 font-bold">
              <div class="transform -rotate-45">
                <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                </svg>
              </div>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasFirst()">
          <a href="#" @click.prevent="changePage(1)">
            <div class="flex hover:bg-gray-200 rounded-md transform rotate-45 h-6 w-6 items-center justify-center">
          <span class="transform -rotate-45">
            {{ $t('message.' + 1) }}
          </span>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasFirst()">...</li>
        <li class="pr-6" 
            v-for="(page, index) in pages.pages"
            :key="index"
        >
          <a href="#" @click.prevent="changePage(page)">
            <div :class="[current == page ? cssClass : '']"
                 class="flex hover:bg-gray-200 rounded-md transform rotate-45 h-6 w-6 items-center justify-center font-bold">
                <span class="transform -rotate-45" v-if="lang">{{ pages.transPages[index] }}</span>
                <span class="transform -rotate-45" v-else>{{ page }}</span>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasLast()">...</li>
        <li class="pr-6" v-if="hasLast()">
          <a href="#" @click.prevent="changePage(totalPages)">
            <div class="flex hover:bg-gray-200 rounded-md transform rotate-45 h-6 w-6 items-center justify-center font-bold">
          <span class="transform -rotate-45">
            {{ totalPageLocale }}
          </span>
            </div>
          </a>
        </li>
        <li class="pr-6" v-if="hasNext()">
          <a href="#" @click.prevent="changePage(nextPage)">
            <div class="flex items-center justify-center hover:bg-gray-200 rounded-md transform rotate-45 h-6 w-6 font-bold">
              <div class="transform -rotate-45">
                <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
              </div>
            </div>
          </a>
        </li>
      </ul>

      <div class="flex items-center">
        <div v-if="isTextInput" class="pr-2 text-gray-400 font-medium">
          <span id="text-before-input">
            {{ textBeforeInput }}
          </span>
        </div>
        <div class="px-1 py-1" :class="isTextInput ? 'w-14' : 'w-10'">
          <input v-model.number="input" :class="isTextInput ? 'w-12 px-2 py-1.5' : 'w-8 p-1'" class="focus:outline-none border border-indigo-400 rounded-md" type="text">
        </div>
        <div @click.prevent="changePage(input)" :class="isTextInput ? 'pl-4' : 'pl-1'" class="flex items-center font-medium cursor-pointer">
          <span id="text-after-input">
            {{ textAfterInput }}
          </span>
          <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </div>
      </div>
    </section>
  </div>
</template>

<style>

</style>

<script>
    import {defineComponent} from 'vue';
    import { currentLocale, transNum } from 'Resources/plugins/i18n';
import helper from '../../util/helper';
    
export default {
    
    name: "Pagination",
    
    props:{
        cssClass: {
            default: "bg-yellow-400 text-white",
            type: String,
            required: false
        },
        lang:{
            default: true,
            type: Boolean
        },
        current: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
        default: 0
        },
        perPage: {
            type: Number,
            default: 9
        },
        pageRange: {
            type: Number,
            default: 2
        },
        isTextInput: {
          default: true,
          type: Boolean,
          required: false,
        },
        textBeforeInput: {
            type: String,
            default: 'Go to page'
        },
        textAfterInput: {
            type: String,
        default: 'Go'
        }
    },
    
    data() {
        return {
            input: '',
        }
    },
    methods: {
        hasFirst: function () {
            return this.rangeStart !== 1
        },
        hasLast: function () {
            return this.rangeEnd < this.totalPages
        },
        hasPrev: function () {
            return this.current > 1
        },
        hasNext: function () {
            return this.current < this.totalPages
        },
        changePage: function (page) {
            page = helper.transPaginate(page);
            
            if (page > 0 && page <= this.totalPages) {
                this.$emit('page-changed', page)
            }
        },
    },
    computed: {
        pages: function () {
            let pages = []
            let transPages = [];
            for (var i = this.rangeStart; i <= this.rangeEnd; i++) {
                pages.push(i);
                transPages.push(transNum(i));
            }
            if (parseInt(this.total/this.perPage) < 1)
              pages = 0

            return {pages, transPages}
        },
        rangeStart: function () {
            let pageRange = this.isTextInput == true ? this.pageRange : this.pageRange - 1;
            var start = this.current - pageRange 
            return (start > 0) ? start : 1
        },
        rangeEnd: function () {
            let pageRange = this.isTextInput == true ? this.pageRange : this.pageRange - 1;
            var end = this.current + pageRange 
            return (end < this.totalPages) ? end : this.totalPages
        },
        totalPages: function () {
            return Math.ceil(this.total / this.perPage)
        },
        totalPageLocale: function () {
            return transNum(Math.ceil(this.total / this.perPage))
        },
        nextPage: function () {
            return parseInt(this.current) + 1
        },
        prevPage: function () {
            return parseInt(this.current) - 1
        }
    }
}
</script>